import React, { useEffect, useState } from "react";
import { IonContent, IonPage } from "@ionic/react";
import { Box, Button, Flex, Grid, Text } from "theme-ui";
import { Product } from "./Products";
import Safezone from "../components/ui/Safezone";
import { useHistory } from "react-router";
import { Cart, ArrowBack } from "../assets/vector/icon";
import Chip from "../components/ui/Chip";
import theme from "../theme/theme";
import { useDispatch } from "react-redux";
import Counter from "../components/ui/Counter";
import ImageProgressive from "../components/ui/ImageProgressive";

const standard = {
  id: "7",
  category: "Fruits",
  title: "Raspberries",
  sub_title: "Glown Ample",
  description:
    "Raspberries are a delicate berry composed of a variety of small stone fruits. The berries can be eaten fresh for dessert, for breakfast, or used as a filling in pies, jellies made from raspberries. In addition, the berry can be cooked for juice, porridge, jam and marmalade. The berries must be stored in the refrigerator but they have a very short shelf life of approx. 1-2 days.",
  tags: "desserts, bakery, breakfast",
  picture_list:
    "data:image/jpeg;base64,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",
  picture_detail: "/assets/products_detail/7.jpg",
  price: "4.11",
  pricePretty: "$4.11",
  picture_preview:
    "data:image/jpeg;base64,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",
} as Product;

const ProductsDetail: React.FC = (props: any) => {
  const productProps: Product | undefined = props.location.state?.product;

  const dispatch = useDispatch();
  const history = useHistory();
  const [product, setProduct] = useState<Product>(productProps || standard);
  const handleGoBack = () => {
    history.goBack();
  };

  const handleGoToCart = () => {
    history.push("/order");
  };

  const handleAddToCart = (productId: string) => {
    dispatch({
      type: "ADD_TO_CART",
      payload: productId,
    });
  };

  useEffect(() => {
    if (productProps && product.id !== productProps.id) {
      setProduct(productProps);
    }
  }, [productProps, product.id]);

  return (
    <IonPage>
      <IonContent fullscreen>
        <Box sx={{ position: "relative", height: "100%" }}>
          <BarTop
            title={product.title}
            goBack={handleGoBack}
            onGoToCart={handleGoToCart}
          />
          <Grid
            gap="1"
            sx={{
              gridTemplateRows: "auto 1fr",
            }}
          >
            <ImageProgressive
              url={product.picture_detail}
              urlPreview={product.picture_preview}
              sxBox={{
                width: "100%",
                height: "50vh",
              }}
              sxImage={{
                objectFit: "cover",
                height: "100%",
                width: "100%",
              }}
            />
            <Detail product={product} />
          </Grid>
          <BarBottom
            onAddToCart={() => handleAddToCart(product.id)}
            onGoToCart={handleGoToCart}
          />
        </Box>
      </IonContent>
    </IonPage>
  );
};

type BarTopProps = {
  title: string;
  goBack: () => void;
  onGoToCart: () => void;
};
function BarTop({ title, goBack, onGoToCart }: BarTopProps) {
  return (
    <Box
      pt="3"
      sx={{
        backdropFilter: "blur(40px)",
        color: "white",
        fill: "white",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 2,
      }}
    >
      <Safezone xOnly>
        <Flex
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            height: "60px",
          }}
        >
          <Flex sx={{ width: "40px", height: "40px" }} onClick={goBack}>
            <ArrowBack />
          </Flex>
          <Text sx={{ fontWeight: "600" }}>{title}</Text>
          <Flex sx={{ width: "40px", height: "40px" }} onClick={onGoToCart}>
            <Counter>
              <Cart />
            </Counter>
          </Flex>
        </Flex>
      </Safezone>
    </Box>
  );
}

type BarBottomProps = {
  onAddToCart: () => void;
  onGoToCart: () => void;
};

function BarBottom({ onAddToCart, onGoToCart }: BarBottomProps) {
  return (
    <Grid
      p="3"
      pb="4"
      sx={{
        width: "100%",
        gridTemplateColumns: "1fr 1.5fr",
        position: "fixed",
        zIndex: "1",
        bottom: "0px",
        backgroundColor: "white",
        borderTop: `1px solid ${theme.colors.gray6}`,
        boxShadow: theme.shadows.element,
      }}
      gap="2"
    >
      <Button variant="secondary" onClick={onAddToCart}>
        Add to cart
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          onAddToCart();
          onGoToCart();
        }}
      >
        Buy Now
      </Button>
    </Grid>
  );
}

function Detail({ product }: { product: Product }) {
  return (
    <Box
      sx={{
        overflow: "scroll",
      }}
      bg="white"
      p="3"
      mb="100px"
    >
      <Flex sx={{ justifyContent: "space-between" }}>
        <Box>
          <Text variant="headline2">{product.title}</Text>
          <Text variant="bodySmall" sx={{ color: "gray3" }}>
            {product.sub_title}
          </Text>
        </Box>
        <Text variant="headline1" sx={{ color: "orange3" }}>
          {product.pricePretty}
        </Text>
      </Flex>
      <Flex my="4">
        {product.tags.split(",").map((tag) => (
          <Chip key={tag}>{tag}</Chip>
        ))}
      </Flex>
      <Box mt="3">
        <Text variant="body" sx={{ color: "gray3" }}>
          {product.description}
        </Text>
      </Box>
    </Box>
  );
}

export default React.memo(ProductsDetail);
